import script from "./WUserCreationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WUserCreationForm.vue?vue&type=script&setup=true&lang=ts"

import "./WUserCreationForm.vue?vue&type=style&index=0&id=db336008&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db336008"]])

export default __exports__